import '../../sass/Contact/index.scss'

document.querySelectorAll('textarea.auto-size').forEach(function (textarea) {
    textarea.style.height = textarea.scrollHeight + 'px'
    textarea.style.overflowY = 'hidden'

    textarea.addEventListener('input', function () {
        this.style.height = 'auto'
        this.style.height = this.scrollHeight + 'px'
    })
})

function fadeAnimate(element) {
    element.style.transition = 'opacity 150ms'
    element.style.opacity = '0.7'

    setTimeout(() => {
        element.style.opacity = '1'
    }, 150)
}

function scrollToElementWithOffset(element) {
    const headerHeight = parseInt(document.documentElement.dataset.headerHeight, 10) || 70
    const elementTop = element.getBoundingClientRect().top + window.scrollY
    const scrollPosition = elementTop - headerHeight

    window.scrollTo({
        top: scrollPosition,
        behavior: 'smooth',
    })
}

document.addEventListener('submit', async function (e) {
    const form = e.target

    console.log('here')

    if (!form.classList.contains('js_contact_form')) return

    e.preventDefault()

    const url = form.getAttribute('action')
    const method = form.getAttribute('method').toUpperCase()
    const formData = new FormData(form)
    const data = new URLSearchParams(formData).toString()

    const success_message = form.querySelector('.js_contact_form_success')
    const error_message = form.querySelector('.js_contact_form_error')

    document.querySelectorAll('.js_contact_field').forEach(el => el.disabled = true)
    document.querySelectorAll('.js_contact_submit').forEach(el => el.disabled = true)

    try {
        const response = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json',
                'X-Requested-With': 'xmlhttprequest',
            },
            body: data,
        })

        window.turnstile.reset()

        if (!response.ok) throw await response.json()

        const result = await response.json()

        error_message.style.display = 'none'

        success_message.innerHTML = result.message
        success_message.style.display = 'block'
        fadeAnimate(success_message)

        document.querySelectorAll('.js_contact_field').forEach(el => el.value = '')

        scrollToElementWithOffset(success_message)
    } catch (errorResponse) {
        window.turnstile.reset()

        success_message.style.display = 'none'

        error_message.innerHTML = errorResponse.message
        error_message.style.display = 'block'
        fadeAnimate(error_message)

        scrollToElementWithOffset(error_message)
    } finally {
        document.querySelectorAll('.js_contact_field').forEach(el => el.disabled = false)
        document.querySelectorAll('.js_contact_submit').forEach(el => el.disabled = false)
    }
})
